import { SignInComponent } from './auth/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { provideRouter, Routes } from '@angular/router';
import { authenticatedGuard } from './auth/guard/authenticated.guard';
import { unauthenticatedGuard } from './auth/guard/unauthenticated.guard';
import { RedirectComponent } from './auth/redirect/redirect.component';
import { DAMO_AUTH_PATHS } from './auth-paths';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { VerifyEmailComponent } from './auth/verify-email/verify-email.component';
import { ActionComponent } from './auth/action/action.component';
import { RevertMfaComponent } from './auth/revert-mfa/revert-mfa.component';
export { DAMO_AUTH_PATHS } from './auth-paths';

export const damoAuthRoutes: Routes = [
  {
    path: DAMO_AUTH_PATHS.SIGN_IN,
    component: SignInComponent,
    canActivate: [unauthenticatedGuard],
  },
  {
    path: DAMO_AUTH_PATHS.REDIRECT,
    component: RedirectComponent,
    canActivate: [authenticatedGuard],
  },
  {
    path: DAMO_AUTH_PATHS.FORGOT_PASSWORD,
    component: ForgotPasswordComponent,
  },
  {
    path: DAMO_AUTH_PATHS.PASSWORD_RESET,
    component: PasswordResetComponent,
  },
  {
    path: DAMO_AUTH_PATHS.VERIFY_EMAIL,
    component: VerifyEmailComponent,
  },
  {
    path: DAMO_AUTH_PATHS.REVERT_MFA,
    component: RevertMfaComponent,
  },
  {
    path: DAMO_AUTH_PATHS.AUTH_ACTION,
    component: ActionComponent,
  },
  {
    path: '',
    redirectTo: DAMO_AUTH_PATHS.SIGN_IN,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: DAMO_AUTH_PATHS.SIGN_IN,
  },
];

export const provideDamoAuthRoutes = () => provideRouter(damoAuthRoutes);
